var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"planet-defender-view"}},[_c('nav-component'),_c('h1',[_vm._v("This the planet defender page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }